import React from "react";

interface ProductVideoProps {
    product_video: string;
    product_video_title: string;
    product_video_detail: string;
    product_video_poster?: string; // اگر خواستی پوستر هم پاس بده
}

const ProductVideo: React.FC<ProductVideoProps> = ({
    product_video,
    product_video_title,
    product_video_detail,
    product_video_poster,
}) => {
    return (
        <figure className="relative sm:h-[800px] h-[400px] w-full">
            <video
                src={process.env.IMAGE_URL + product_video}
                poster={product_video_poster ? process.env.IMAGE_URL + product_video_poster : undefined}
                autoPlay
                loop
                muted
                playsInline
                className="absolute top-0 left-0 w-full h-full object-cover z-[-1]"
                aria-label={product_video_title}
                title={product_video_title}
                tabIndex={0}
            >
                {product_video_title} - {product_video_detail}
            </video>
            {/* <figcaption className="absolute bottom-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center text-white pointer-events-none">
                <h2 className="text-2xl font-bold mb-2 drop-shadow-lg">{product_video_title}</h2>
                <p className="text-base drop-shadow-md">{product_video_detail}</p>
            </figcaption> */}
        </figure>
    );
};

export default ProductVideo;
